<template>
  <div class="flex items-center h-full">
    <div class="color-chip" :style="{ background: colorHex }"></div>
  </div>
</template>

<script>
export default {
  computed: {
    colorHex() {
      return this.params.data.color_hex
        ? `#${this.params.data.color_hex}`
        : `#ffffffff`;
    },
  },
};
</script>

<style lang="scss" scoped>
.color-chip {
  min-width: 25px;
  max-width: 25px;
  height: 25px;
  border-radius: 15px;
}
</style>
